var _style, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnnessaar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000020359148516635113580000015359342631451712186_);}\r\n\t.st2{fill:url(#SVGID_00000077311423066936879250000009385756472829943470_);}\r\n\t.st3{fill:url(#SVGID_00000134933276594610713230000000486967035127327380_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.4389,
    y1: 493.7586,
    x2: 285.9791,
    y2: 493.7586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3E60AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2691,
    style: {
      stopColor: "#4D71B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CD5EA"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "194.8,402.6 103.6,493.8 12.4,584.9 194.8,584.9 286,493.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039820097907219818570000015433246062696205236_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.4389,
    y1: 356.989,
    x2: 377.1542,
    y2: 356.989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#638BC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583,
    style: {
      stopColor: "#465EAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8214,
    style: {
      stopColor: "#4559A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4450A2"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000039820097907219818570000015433246062696205236_)"
    },
    points: "286,311.4 286,311.4 194.8,220.2  12.4,220.2 103.6,311.4 194.8,402.6 194.8,402.6 286,493.8 377.2,402.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141456005128698150660000011661094226597666731_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.0209,
    y1: 288.6033,
    x2: 587.5611,
    y2: 288.6033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4A1CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08498454,
    style: {
      stopColor: "#C996C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4152,
    style: {
      stopColor: "#A36CAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    style: {
      stopColor: "#945CA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7516,
    style: {
      stopColor: "#8E57A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9774,
    style: {
      stopColor: "#7D499D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7B479C"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000141456005128698150660000011661094226597666731_)"
    },
    points: "496.4,288.6 405.2,197.4  314,288.6 405.2,379.8 587.6,379.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046314352528603728330000003372399382649217453_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.8352,
    y1: 151.8341,
    x2: 587.561,
    y2: 151.8341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C419A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    style: {
      stopColor: "#544CA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2629,
    style: {
      stopColor: "#5A55A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#5C58A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#867CBA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000046314352528603728330000003372399382649217453_)"
    },
    points: "587.6,15.1 405.2,15.1 314,106.2  314,106.3 222.8,197.4 314,288.6 314,106.3 314,106.3 314,288.6 405.2,197.4 405.2,197.4 496.4,106.2  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnnessaar);
export default __webpack_public_path__ + "static/media/Ennessaar.83d1a90547d70eb1c62c94706ca30b8c.svg";
export { ForwardRef as ReactComponent };